module.exports = __webpack_public_path__ + "2eb505fceb5a20c85b5e451d2b4afce3.pdf";